import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-mist" data-id="element-36" data-mp="2bju8fjocf3ie">
      <div className="mx-auto max-w-3xl px-3 py-5 sm:px-6 sm:py-7" data-id="element-37" data-mp="2bmgqwecrv3fe">
        <Reveal data-id="element-38" data-mp="2fknvkatyoea8">
          <SectionHeading id="faq" title="Preguntas frecuentes" data-id="element-39" data-mp="2flfotf035zxc" />
        </Reveal>

        <div className="mt-2.5 grid gap-1.5" data-id="element-40" data-mp="21trg7lp1ptl4">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-md border border-navy/10 bg-white" data-id="element-41" data-mp="2uj85wbla6wdn" data-mpi={i}>
                <h3 data-id="element-42" data-mp="2za6rnqp1gmoa">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left" data-id="element-43" data-mp="2zbhrjffd5aa4">
                    <span className="text-[0.8rem] font-bold text-navy sm:text-[0.84rem]" data-id="element-44" data-mp="20oui0n6hb4x0">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-azure transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-45" data-mp="2fcfi08824o0p" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-46" data-mp="2jg532npiwngz">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-47" data-mp="u0xme8k7gfne">
                      <p className="px-3 pb-2 font-body text-[0.76rem] leading-snug text-steel sm:text-[0.8rem]" data-id="element-48" data-mp="2z0yp2sfm08bl">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}